'use client'

import { AxiosError } from 'axios'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useState } from 'react'
import { forgotPassword } from '../services/api'

const formSchema = z.object({
  tenant: z.string().min(1, 'Müşteri kodu zorunludur'),
  email: z.string().email('Geçersiz email'),
})

type FormValues = z.infer<typeof formSchema>

export function useForgotPasswordForm() {
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      tenant: '',
      email: '',
    },
  })

  const onSubmit = async (values: FormValues) => {
    setErrorMessage(null)
    setIsSuccess(false)
    setIsLoading(true)

    try {
      await forgotPassword({
        email: values.email,
        tenant: values.tenant,
      })
      setIsSuccess(true)
    } catch (error) {
      if (error instanceof AxiosError) {
        setErrorMessage(error.response?.data?.error || 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.')
      } else {
        setErrorMessage('Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.')
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { form, isSuccess, isLoading, errorMessage, onSubmit }
}
